import { createVanIconComponent } from "./van"

const StarOutlined = createVanIconComponent("star-o")
export default StarOutlined
